<template>
  <div>
        <div class="form-data">
            <div class="d-cent-name"><left-text leftText="酒店名称" type="number"/>{{ teamInfo.title }}</div>
            <left-text-border leftText="联系人" type="text" class="w-100 mt-3"   v-model="formData.contact" @blur="validateFun(1)"/>
            <div class="d-cent-name mt-1" v-if="rules.contact.required"><left-text leftText="" type="number"/><span class="corls">{{ rules.contact.message}}</span></div>
            <left-text-border leftText="手机号" type="number" class="w-100 mt-3" v-model="formData.mob" @blur="validateFun(0)"/>
            <div class="d-cent-name mt-1" v-if="rules.mob.required"><left-text leftText="" type="number"/><span class="corls">{{ rules.mob.message}}</span></div>
        </div>
        <div  class="d-cent-name comt mt-4">
            <el-button @click="$emit('createAccount')">取消</el-button>
            <el-button type="primary" @click="createStoreUsername()">确认创建</el-button>
        </div>
  </div>
</template>

<script>
import { mapState,mapGetters,mapActions} from 'vuex'
export default {
  name: '',
  components: {},
  props: {
        teamInfo: {
            type: Object,
            default: () => {}
        },
        storeType: {
            type: String,
            default: '0'
        },
  },
  data() {
    return {
        formData: {
            contact: '',
            mob: ''
        },
        rules:{
          contact:{ required: false, message: '请填写联系人'},
          mob:{ required: false, message: '请填写正确的手机号'},
        },
    };
  },
  computed: {},
  watch: {},
  created() {},
  mounted() {},
  methods: {
        ...mapActions(['POST_Admin_CreateStoreUsername']),
        //创建门店企业账号
        createStoreUsername(item){
            //验证表单
            let result=this.validateFun(0);
            if (result.code) {
                this.formData.store_id = this.teamInfo.id;
                this.formData.store_type = this.storeType;
                this.POST_Admin_CreateStoreUsername({
                data:this.formData,
                successFun: () => {
                    this.$emit('createAccountSuccess');
                },
                })
            }
        },
        /*表单验证函数*/
        validateFun(validateType = 0) {
            const { formData = {}, rules } = this;
            // 验证联系人
            rules.contact.required = !formData.contact;
            if (rules.contact.required) return {};
            // 验证手机号（仅validateType=0时）
            if (validateType === 0) {
            rules.mob.required = !this.$GFUN.isPhone(formData.mob);
            if (rules.mob.required) return {};
            }
            return { code: true };
        },
  }
};
</script>

<style lang="scss" scoped>
    .d-cent-name{
        display:flex;
    }
    .comt{
        justify-content:center;
    }
    .corls{
        color:red;
        font-size: 12px;  
    }
</style>
